export default class SizeType {
  fromPrice = 0;
  availableAmount = 0;
  width = 0;
  height = 0;
  length = 0;
  sizeInSquareMeters = 0;
  levelAmount = 0;
  levelPrice = [];

  constructor(
    id,
    title,
    description,
    sizeInSquareMeters,
    sizeTypes,
    images,
    formSize
  ) {
    this.id = id;
    this.title = title;
    this.description = description;
    this.sizeInSquareMeters = sizeInSquareMeters;
    this.sizeTypes = sizeTypes;
    this.images = images;
    this.formSize = formSize ?? null;
  }
}
